
































































































import Vue from 'vue'
import { uploadPOST } from '@/api/api'
import dayjs from 'dayjs'
import * as _ from 'lodash'
import {
  FolderServiceProxy,
  ResourceServiceProxy,
  ManageDirectoryServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
import { ServiceProxy as ObsFileServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

const ofsp = new ObsFileServiceProxy()
const fsp = new FolderServiceProxy()
const rsp = new ResourceServiceProxy()
const mdsp = new ManageDirectoryServiceProxy()
export default Vue.extend({
  name: 'UploadDocument',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileRecords: {
        programs: [],
        documents: []
      },
      selectOringinVisible: false,
      fileTreeVisible: false,
      treeFiles: [], // 选中的文档
      treeData: [], // 我的文档目录
      dncTreeData: [], // 工艺文件目录
      originalFiles: [],
      fileTypes: {
        1: 'programs',
        2: 'documents'
      },
      currentfileType: 1,
      validateFile: true,
      loading: true, // 上传状态
      currentType: 0, // 0:我的文档，1：工艺文件
      loadedKeys: [],
      allLoadedDncFiles: [], // 所有已经加载的工艺文件
      dncTreeFiles: [] // 选中的工艺文件
    }
  },
  computed: {
    uploadGroup() {
      return [
        {
          title: this.$t('page_my_document_program'),
          label: this.$t('page_my_document_addprogram'),
          type: 1
        },
        {
          title: this.$t('page_my_document_process'),
          label: this.$t('page_my_document_addprocess'),
          type: 2
        }
      ]
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.loading = false
          this.fileRecords = {
            programs: [],
            documents: []
          }
          this.dncTreeData = []
          this.getDncFiles()
        }
      },
      immediate: true
    },
    fileTreeVisible(val) {
      if (val) {
        this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
        this.originalFiles = []
        this.treeFiles = []
        this.dncTreeFiles = []
        this.allLoadedDncFiles = []
      }
    },
  },
  created() {
    this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
  },
  methods: {
    // 加载我的文档树数据
    loadTreeData(treeNode) {
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        fsp.folderList(treeNode.dataRef.key, '').then(res => {
          this.originalFiles = this.originalFiles.concat(res.fileList)
          let files, folders
          files = res.fileList.map(file => ({ title: file.name, key: file.id, isLeaf: true }))
          folders = res.folderList.map(folder => ({ title: folder.name, key: folder.id, checkable: false }))
          treeNode.dataRef.children = [...files, ...folders]
          this.treeData = [...this.treeData]
          resolve()
        })
      })
    },
    // 加载工艺文件数据:获取管理目录树接口
    async getDncFiles() {
      const res = await mdsp.treeList(0)
      if (res && res.length) {
        this.dncTreeData = this.handleDncTree(res)
      } else {
        this.dncTreeData = [{
          key: '0',
          // title: this.$t('page_business_data_process_documents'),
          title: this.$t('page_wm_empty'),
          checkable: false,
          slots: { icon: 'Tree.vue' },
          children: []
        }]
      }
    },
    handleDncTree(data: any) {
      data.map((item) => {
        item.checkable = false
        item.key = item.id
        item.slots = { icon: 'Tree.vue' }
        // this.loadedKeys.push(item.id)
        // let child = await this.getPackage(item.id)
        // item.children = [item.children, ...child]
        if (item.children && item.children.length) {
          this.handleDncTree(item.children)
        }
      })
      return data
    },
    // 点击展开图标，加载工艺文件
    loadDncTreeData(treeNode) {
      console.log(treeNode)
      let res
      let pack = []
      return new Promise(async (resolve) => {
        if (treeNode.dataRef.children && treeNode.dataRef.children.findIndex(child => child.slots && child.slots.icon === 'folder') > -1) {
          resolve()
          return
        }
        if (treeNode.dataRef.slots && treeNode.dataRef.slots.icon === 'Tree.vue') { // 一级:获取目录下的工艺包
          res = await rsp.list(treeNode.dataRef.key, {})
          res = res.filter(item=>item.state==='PUBLISHED') // 只显示已发布的工艺包
          if (res && res.length) {
            pack = res.map(item => ({
              title: item.displayName,
              key: item.id,
              checkable: false,
              slots: { icon: 'folder' }, ...item
            }))
            treeNode.dataRef.children = [...treeNode.dataRef.children, ...pack]
            this.dncTreeData = [...this.dncTreeData]
          }
          resolve()
        } else if (treeNode.dataRef.slots && treeNode.dataRef.slots.icon === 'folder') { // 二级:获取工艺包下面的文件
          res = await rsp.resourceFileList(treeNode.dataRef.key)
          if (res && res.length) {
            pack = res.map(item => ({
              title: item.displayName,
              key: item.id,
              isLeaf: true,
              ...item
            }))
            // 将已经加载出来的文件合并到一个数组内
            this.allLoadedDncFiles = [...this.allLoadedDncFiles, ...pack]
            // console.log('allLoadedDncFiles：', this.allLoadedDncFiles)
            treeNode.dataRef.children = []
            treeNode.dataRef.children = [...treeNode.dataRef.children, ...pack]
            console.log()
            this.dncTreeData = [...this.dncTreeData]
          }
          resolve()
        }
      })
    },
    // 打开文件源选择框
    openOriginSelectModal(type: number) {
      this.currentfileType = type
      this.selectOringinVisible = true
    },
    // 打开我的文档树选框
    openTreeUpload(type: string) {
      this.selectOringinVisible = false
      this.fileTreeVisible = true
      this.currentType = type && type === 'my' ? 0 : 1
      this.$nextTick(() => {
        const tree = this.$refs.aTree.$el
        const firstNode: any = tree.getElementsByClassName('ant-tree-switcher')
        if (firstNode[0]) {
          firstNode[0].click()
        }
      })
    },
    // 上传我的文档中选中的文件
    handleTreeUpload() {
      let files = []
      if (!this.currentType) {
        files = this.originalFiles
          .filter(item => {
            return this.treeFiles.includes(item.id)
          })
          .map(item => {
            return {
              contentLength: item.contentLength,
              contentMd5: item.contentMd5,
              contentType: item.contentType,
              filename: item.objectKey,
              originalFilename: item.name,
              objectKey: item.objectKey,
              suffix: item.suffix,
              lastModified: dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss'),
              fileType: this.currentfileType,
              fileSource: 1
            }
          })
      } else if (this.currentType === 1) { // 工艺文档
        // console.log('this.dncTreeFiles======>', this.dncTreeFiles)
        files = this.allLoadedDncFiles.filter(item => this.dncTreeFiles.includes(item.id)).map(item => ({
          contentLength: item.contentLength,
          contentMd5: item.contentMd5,
          contentType: item.contentType,
          filename: item.objectKey,
          originalFilename: item.displayName,
          objectKey: item.objectKey,
          suffix: item.suffix,
          lastModified: dayjs(item.createDatetime).format('YYYY-MM-DD HH:mm:ss'),
          fileType: this.currentfileType,
          fileSource: 2
        }))
      }
      const filterFiles = []
      for (let f of files) {
        const flag = this.fileRecords[this.fileTypes[this.currentfileType]].find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          filterFiles.push({ ...f })
        }
      }
      this.fileRecords[this.fileTypes[this.currentfileType]] = [...this.fileRecords[this.fileTypes[this.currentfileType]], ...filterFiles]
      // this.fileRecords = _.cloneDeep(this.fileRecords)
      this.fileTreeVisible = false
    },
    // 上传：方法二
    uploadFile(file: any) {
      this.selectOringinVisible = false
      // console.log('上传文件', file.file)
      let uid = file.file.uid
      let targetFile = file.file
      let fileSuffix = targetFile.name.lastIndexOf(".") > 0 ? targetFile.name.substring(targetFile.name.lastIndexOf(".") + 1) : ""
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      uploadPOST(formData).then(async (res: any) => {
        if (res.data.data) {
          let data = res.data.data

          const ossfile = await (await ofsp.statFileUsingGET(data.name)).data

          // fileSource: 文件来源 0：本地文档 1：非资源 2：资源 4：回传文件;  fileType 1：加工文件  2：工艺文件
          Object.assign(data, { 
            fileSource: 0, 
            fileType: this.currentfileType,
            contentLength: ossfile.length,
            contentMd5: ossfile.hash,
            contentType: ossfile.contentType,
            originalFilename: data.originalName,
            objectKey: data.name,
            suffix: fileSuffix
          })

          // 上传成功
          this.fileRecords[this.fileTypes[this.currentfileType]].forEach(item => {
            if (item.uid && item.uid === uid) {
              Object.assign(item, data)
            }
          })
        }
        // console.log(this.fileRecords)
      }, (err: any) => {
        // 上传失败，从列表移除
        let index = this.fileRecords[this.fileTypes[this.currentfileType]].findIndex(item => item.uid === uid)
        this.fileRecords[this.fileTypes[this.currentfileType]].splice(index, 1)
        this.$message.error(this.$t('page_transport_directory_upload_failed'))
      }).finally(() => {
        this.fileRecords = _.cloneDeep(this.fileRecords)
        this.loading = false
      })
    },
    // 上传的文件状态改变时，添加，删除
    handleChange(info: any) {
      // console.log(info)
      if (!this.validateFile) {
        return
      }
      // 过滤同名
      const index = this.fileRecords[this.fileTypes[this.currentfileType]].findIndex(item => item.name === info.file.name)
      if (index > -1) {  // 有重复文件，覆盖
        this.fileRecords[this.fileTypes[this.currentfileType]].splice(index, 1, info.file)
      } else { // 未重复，直接添加
        this.fileRecords[this.fileTypes[this.currentfileType]].push(info.file)
      }
    },
    // 删除已上传的文件
    removeFile(objectKey: any, fileType: number) {
      // 从列表删除
      let index = this.fileRecords[this.fileTypes[fileType]].findIndex(file => file.objectKey === objectKey)
      this.fileRecords[this.fileTypes[fileType]].splice(index, 1)
      // 从接口删除
      ofsp.removeFileUsingPOST(objectKey)
    },
    // 上传之前的校验
    beforeUpload(file: any) {
      // console.log('beforeUpload:', file)
      let isLt = null

      // 单位MB
      isLt = file.size / 1024 / 1024 < 20
      this.validateFile = isLt
      if (!isLt) {
        // 校验失败，更改文件上传的状态为error；并传入fileType，方便删除时使用
        // Object.assign(file, { status: 'error', fileType: this.currentfileType })
        this.$message.error(
          `${this.$t('page_transport_directory_upload_limit')} 20MB!`
        )
      }
      return isLt
    }
  }
})
